import { createFileRoute, redirect, useSearch } from '@tanstack/react-router';
import { Permission } from '../../features/auth';
import { CaseCartDetailPage } from '../../features/case-cart-assembly';

export const Route = createFileRoute('/_auth/case-cart-assembly-detail')({
  staticData: {
    title: 'pages.caseCartAssembly.progressScreen.title',
    description: 'pages.caseCartAssembly.progressScreen.description',
  },
  validateSearch: (search: Record<string, unknown>) => ({
    caseId: (search.caseId as string | undefined) ?? undefined,
  }),
  beforeLoad: async ({ context, search }) => {
    const { isAuthenticated, hasPermission, isAdmin } = context.auth;

    if (!isAuthenticated) throw redirect({ to: '/' });
    if (!hasPermission(Permission.CART_BUILDER) && !isAdmin())
      throw redirect({ to: '/403' });

    const caseId = search.caseId as string | undefined;
    if (!caseId) throw redirect({ to: '/case-cart-assembly' });
  },
  component: CaseCartAssemblyDetailRoute,
});

function CaseCartAssemblyDetailRoute() {
  const { caseId } = useSearch({ from: '/_auth/case-cart-assembly-detail' });
  return <CaseCartDetailPage caseId={caseId as string} />;
}
